import {Component, EventEmitter, Input, OnChanges, SimpleChanges, OnInit, Output} from '@angular/core';
import {CampoAggiuntivo, CampoUtility} from "../models/campo-aggiuntivo";
import {is} from "date-fns/locale";

@Component({
  selector: 'app-checkbox-array-viewer',
  templateUrl: './checkbox-array-viewer.component.html',
  styleUrls: ['./checkbox-array-viewer.component.css']
})
export class CheckboxArrayViewerComponent implements  OnChanges {
  @Input() Oggetto: any;
  @Output() OggettoChange = new EventEmitter();
  @Output() CheckListChange = new EventEmitter();
  @Input() titolo : string;
  @Output() OnChange = new  EventEmitter<{OnChange: string, Event: any}>();
  @Input() MutualmenteEsclusivi: boolean;
  @Input() campoAggiuntivo: CampoAggiuntivo;
  @Input() HideCampiAgg: boolean = false;
  @Input() isNewView: boolean = false;
  CheckListSelezionato: any;
  CheckListList: any[] = []

  DropdownSources = {}
  _checklist: {check:string, id: number, risposta: boolean, fields: CampoAggiuntivo[]}[];
  @Input()
  public set CheckList(value: {check:string, id: number, risposta: boolean, fields: CampoAggiuntivo[]}[]) {
    if (value) {
      this._checklist = value;
      this.CheckListList = this._checklist.filter(x=>x.risposta);
    } else {
      this._checklist= [];
    }
  }
  public get CheckList(): {check:string, id: number, risposta: boolean, fields: CampoAggiuntivo[]}[] {
    return this._checklist;
  }


  ngOnChanges(changes:SimpleChanges): void {
    this.CheckList?.forEach(check => check.fields?.forEach(field=>{
      field.allowedCapacity = this.campoAggiuntivo?.allowedCapacity;
      field.hideif = this.campoAggiuntivo?.hideif;
      field.disabledif = this.campoAggiuntivo?.disabledif;
      field.AllowedRoles = this.campoAggiuntivo?.AllowedRoles;
      field.prohibitedRoles = this.campoAggiuntivo?.prohibitedRoles;
      field.visibleifProhibited = this.campoAggiuntivo?.visibleifProhibited;
    }))

    if(!this.isNewView)
      this.CheckListList = this.CheckList;
  }

  hasCampiAggiuntiviCheckbox(array: {check?:string, id?: number, risposta?: boolean, fields?: CampoAggiuntivo[]}[]){
    return array?.find(x=>x.fields?.length > 0) != undefined && !this.HideCampiAgg;
  }

  checkChange(item: { check: string; id: number; risposta: boolean; fields: CampoAggiuntivo[] }) {

    if( this.MutualmenteEsclusivi && item.risposta && item.id == 33 && this.CheckList?.find(x=>x.id == 34))
       this.CheckList.find(x=>x.id == 34).risposta = false;
    else if(this.MutualmenteEsclusivi && item.risposta && item.id == 34 && this.CheckList?.find(x=>x.id == 33))
       this.CheckList.find(x=>x.id == 33).risposta = false;

    this.OnChange.emit({ OnChange: 'getPrice', Event: item });
  }

  Change(event: { OnChange: string; Event: any,Oggetto: any }) {
    event.Oggetto['totale'] = parseInt(event.Oggetto['prezzo']?.toString() ?? '0') * parseInt(event.Oggetto['numero']?.toString() ?? '0');
    console.log(event.Oggetto);
    this.OnChange.emit(event);
    this.OnChange.emit({ OnChange: 'getPrice', Event: event.Oggetto });
  }
  unselectedCheckList(){
    return this.CheckList?.filter(x=>!x.risposta);
  }

  CampiModificabili(check ){

    return this.CheckList?.find(x=>x.id ==check.id)?.fields?.filter(x=>x.modificabile);
  }
  CampiNonModificabili(check, head ){
    if(!head)
      return this.CheckList?.find(x=>x.id ==check.id)?.fields?.filter(x=>!x.modificabile);
    else
      return this.CheckList?.find(x=>x.id ==check.id)?.fields?.filter(x=>!x.modificabile && head.nome.includes(x.nome));
  }
  HasCampiNonModificabili(){
    var checks = this.CheckListList;
    if(checks.some(x=>x.fields?.filter(y=>!y.modificabile).length > 0)){
      var head = [];
      checks.forEach(check=> head = [...head, ...check.fields?.filter(y=>!y.modificabile)] );
      return [...new Map(head?.map(item => [item.nome, item])).values()]
    }return []

  }
  addCheck(){
    this.CheckList.find(x=>x.id == this.CheckListSelezionato.id).risposta = true;
    this.CheckListList = this.CheckList.filter(x=>x.risposta);
    this.OnChange.emit({ OnChange: 'getPrice', Event: this.CheckListSelezionato });
    this.CheckListSelezionato = null;
  }

  protected readonly is = is;
}
